export default __webpack_public_path__ + "static/saw-4ea9d4444f36f90565354a0cc3740c3f.png";